"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var de_form_module_loading_service_1 = require("./services/de-form-module-loading.service");
var idm_dynamic_layout_designer_1 = require("@synisys/idm-dynamic-layout-designer");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var dynamic_forms_factories_1 = require("./dynamic-forms-factories");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_lock_service_client_js_1 = require("@synisys/idm-lock-service-client-js");
var ɵ0 = dynamic_forms_factories_1.formModuleRegistryFactory, ɵ1 = function (kbService) { return function (category) { return kbService.getMetaFields(category); }; };
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
var DeDynamicFormsModule = /** @class */ (function () {
    function DeDynamicFormsModule() {
    }
    DeDynamicFormsModule = __decorate([
        core_1.NgModule({
            imports: [idm_dynamic_forms_ui_1.DynamicFormsUiModule, idm_dynamic_layout_designer_1.FormBuilderModule],
            providers: [
                de_form_module_loading_service_1.DeFormModuleLoadingService,
                {
                    provide: idm_dynamic_layout_interpreter_1.formModuleRegistryKey,
                    useFactory: ɵ0,
                    deps: [de_form_module_loading_service_1.DeFormModuleLoadingService]
                },
                {
                    provide: idm_dynamic_layout_interpreter_1.fieldsProviderKey,
                    useFactory: ɵ1,
                    deps: [idm_kb_service_client_js_1.KbService]
                },
                { provide: idm_de_service_client_js_1.DeService, useClass: idm_de_service_client_js_1.HttpDeService },
                { provide: idm_de_service_client_js_1.DataService, useClass: idm_de_service_client_js_1.HttpDataService },
                { provide: idm_de_service_client_js_1.DePermissionService, useClass: idm_de_service_client_js_1.HttpDePermissionService },
                { provide: idm_classifier_service_client_js_1.EntityAuditService, useClass: idm_classifier_service_client_js_1.EntityAuditHttpService },
                { provide: idm_lock_service_client_js_1.LockingService, useClass: idm_lock_service_client_js_1.LockingHttpService },
            ]
        })
    ], DeDynamicFormsModule);
    return DeDynamicFormsModule;
}());
exports.DeDynamicFormsModule = DeDynamicFormsModule;
//# sourceMappingURL=de-dynamic-forms.module.js.map